module.exports = __webpack_public_path__ + "static/media/WhatsApp.472af839.svg";